import React from 'react';
import PropTypes from 'prop-types';
import './Anchor.css';

const getAttributes = (newTab) => {
  if (!newTab) return {};

  return {
    rel: 'noopener noreferrer',
    target: '_blank'
  };
};

const Anchor = ({ newTab, href, children }) => {
  const attrs = getAttributes(newTab);

  return (
    <a href={href} {...attrs}>
      {children}
    </a>
  );
};

Anchor.propTypes = {
  newTab: PropTypes.bool.isRequired,
  href: PropTypes.string,
  children: PropTypes.node.isRequired
};

Anchor.defaultProps = {
  href: '#'
};

export { Anchor as default, getAttributes };
